import clsx from 'clsx'
import { Param } from 'shared/search-adapters'
import { FieldSet, Radio } from 'shared/ui'

import css from './Filters.module.css'

const ANSWER_OPTIONS = [
	{ label: 'Yes', value: 1 },
	{ label: 'No', value: 2 },
	{ label: 'Any', value: 0 }
]

function parse(params: URLSearchParams, form: HTMLFormElement) {
	const radios = form.answered as RadioNodeList

	if (radios instanceof RadioNodeList) {
		const value = radios.value
		if (value === '0') {
			params.delete(Param.GotAnswer)
		} else {
			params.set(Param.GotAnswer, value)
		}
	}
}

Answered.parse = parse

export function Answered({ initial = 0 }: { initial?: number }) {
	return (
		<FieldSet
			className={clsx(css.set, css.status)}
			key={Number(initial)}
			legend='Contact Replied'
			legendCN={clsx(css.label, css.label)}
			level='h5'
		>
			{ANSWER_OPTIONS.map(({ label, value }) => {
				return (
					<label className={css.radio} key={label}>
						<Radio
							defaultChecked={value === initial}
							name='answered'
							value={Number(value)}
						/>
						{label}
					</label>
				)
			})}
		</FieldSet>
	)
}
